window.addEventListener("scroll", hideHeader);
function hideHeader() {
  const header = document.querySelector("header");
  let isScrollingUp = false;
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  if (scrollTop > 500) {
    isScrollingUp = false;
  } else {
    isScrollingUp = true;
  }

  if (isScrollingUp) {
    header.style.transform = "translateY(0)";
  } else {
    header.style.transform = "translateY(-100%)";
  }

  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
}

window.addEventListener("scroll", handleScroll);
function handleScroll() {
  const targetElement = document.querySelector(".contentIndicators");
  const targetPosition = targetElement.getBoundingClientRect().top;
  const screenHeight = window.innerHeight;

  const targetValues = [200, 100, 340, 40, 1000, 400, 100];
  const resultNodes = document.querySelectorAll(".item .itemNumber span");

  function updateNumber(targetValue, resultNode) {
    const startValue = parseInt(resultNode.innerText);
    const increment = Math.ceil((targetValue - startValue) / 100);
    const currentValue = parseInt(resultNode.innerText);

    if (currentValue < targetValue) {
      const newValue = currentValue + increment;
      resultNode.innerText = newValue;
      setTimeout(() => updateNumber(targetValue, resultNode), 10);
    } else {
      resultNode.innerText = targetValue;
    }
  }

  if (targetPosition < screenHeight) {
    resultNodes.forEach((resultNode, index) => {
      updateNumber(targetValues[index], resultNode);
    });
    window.removeEventListener("scroll", handleScroll);
  }
}

document.querySelector(".explore").addEventListener("click", scrollToSection);
function scrollToSection() {
  const targetElement = document.getElementById("section2");
  if (targetElement) {
    targetElement.scrollIntoView({
      behavior: "smooth",
    });
  }
}

// events
const button1 = document.getElementById("button1");
const button2 = document.getElementById("button2");
const button3 = document.getElementById("button3");
const button4 = document.getElementById("button4");
const faq = document.getElementById("faq");
const pp = document.getElementById("pp");
const tc = document.getElementById("tc");
const facebook = document.getElementById("iconFacebook");
const instagram = document.getElementById("iconInstagram");
const twitter = document.getElementById("iconTwitter");

function sendEventLandingLoad() {
  window.dataLayer.push({
    affiliate_landing__screen__load: true,
  });
}

function sendEventButtonClick(value) {
  window.dataLayer.push({
    affiliate_landing__quiz_button__click: value,
  });
}

function sendEventFooterButtonClick(value) {
  window.dataLayer.push({
    affiliate_landing__footer_button__click: value,
  });
}

function sendEventSMButtonClick(value) {
  window.dataLayer.push({
    affiliate_landing__sm_button__click: value,
  });
}

window.addEventListener("load", () => {
  sendEventLandingLoad();
});

button1.addEventListener("click", function () {
  sendEventButtonClick("take_the_quiz");
});

button2.addEventListener("click", function () {
  sendEventButtonClick("get_started1");
});

button3.addEventListener("click", function () {
  sendEventButtonClick("get_started2");
});

button4.addEventListener("click", function () {
  sendEventButtonClick("start_your_journey");
});

faq.addEventListener("click", function () {
  sendEventFooterButtonClick("faq");
});

pp.addEventListener("click", function () {
  sendEventFooterButtonClick("pp");
});

tc.addEventListener("click", function () {
  sendEventFooterButtonClick("terms");
});

facebook.addEventListener("click", function () {
  sendEventSMButtonClick("fb");
});

instagram.addEventListener("click", function () {
  sendEventSMButtonClick("insta");
});

twitter.addEventListener("click", function () {
  sendEventSMButtonClick("twitter");
});

// link buttons logic
document.addEventListener("DOMContentLoaded", function () {
  const link = "https://verv.health/v2/plan/?config=walking&walkingDesignV2=true&fsv1f2=true&utm_campaign=aff_partner";
  // const link = "https://dev-health.verv.com/v2/plan/?config=walking&walkingDesignV2=true&fsv1f2=true";
  const buttons = document.querySelectorAll(".button");
  buttons.forEach((button) => {
    button.addEventListener("click", function () {
      setTimeout(() => {
        window.location.href = link;
      }, 200);
    });
  });
});

// promocode logic
const prcWrapper = document.querySelector(".promocodeWrapper");
const prcInput = document.querySelector(".promocodeInput");
const prcButton = document.querySelector(".promocodeWrapperButton");
const originalPlaceholder = prcInput.placeholder;
const linkWprc = "https://verv.health/v2/plan/?config=walking&walkingDesignV2=true&fsv1f2=true&apc=true&utm_campaign=aff_partner";
// const linkWprc = "https://dev-health.verv.com/v2/plan/?config=walking&walkingDesignV2=true&fsv1f2=true&apc=true";
const prcvv = [
  "TV19",
  "Healthnews",
  "Deal",
  "Aff19",
  "Demain19",
  "S19",
  "D19",
  "today19",
  "off19",
  "minus19",
  "SIMPLYCODES19",
];

function checkPromocode() {
  const value = prcInput.value;
  if (prcvv.includes(value)) {
    hideError();
    sendEventButtonClickApplyPromocode();
    goToLink();
  } else {
    showError();
  }
}

function goToLink() {
  setTimeout(() => {
    window.location.href = linkWprc;
  }, 200);
}

function sendEventButtonClickApplyPromocode() {
  window.dataLayer.push({
    quiz_activity: "apply_promocode",
    event: "quiz_funnel",
  });
}

function showError() {
  prcWrapper.classList.add("error");
}

function hideError() {
  if (document.querySelector(".error")) {
    prcWrapper.classList.remove("error");
  }
}

prcInput.addEventListener("input", () => {
  const value = prcInput.value;
  if (value) {
    hideError();
  }
});

prcInput.addEventListener("focus", () => {
  prcWrapper.classList.add("active");
  prcInput.placeholder = "";
  prcWrapper.classList.add("labelActive");
});

prcInput.addEventListener("blur", () => {
  const value = prcInput.value;

  if (!value) {
    prcWrapper.classList.remove("active");
    prcInput.placeholder = originalPlaceholder;
    prcWrapper.classList.remove("labelActive");
  }

  if (value) {
    prcWrapper.classList.add("active");
  }
});

prcButton.addEventListener("click", function () {
  checkPromocode();
});
